<template>
  <div class="p-menu-summary">
    <h1 v-if="menu && menu.headerData" class="p-menu-summary__title">
      {{ menu.headerData.catchCopy }}
    </h1>
    <template v-if="menu && menu.headerData">
      <p v-html="genHtmlInText(menu.headerData.leadCopy)" class="p-menu-summary__description"></p>
    </template>

    <ul class="p-menu-summary__hash-tags" v-if="menu">
      <li
        v-for="(item, i) in menu.menuHashtags"
        :key="i"
        class="p-menu-summary__hash-tags__item"
      >
        <a href="javascript:;" @click="onSearch(item.freeWord)">
          #{{ item.freeWord }}
        </a>
      </li>
    </ul>
    <p v-if="hasInqFormUrl" class="open-in-new">
      <a :href="menu && menu.providerInfo.inqFormUrl"><span>問い合わせフォームはこちら</span><Icon name="open_in_new"/></a>
    </p>
    <p v-if="hasInq" class="open-in-new">
      <a :href="menu && menu.providerInfo.hpUrl"><span>提供企業サイトはこちら</span><Icon name="open_in_new"/></a>
    </p>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue"
export default {
  props: {
    title: String,
    description: String,
    tags: Array,
    menu: {
      type: Object
    }
  },
  components:{
    Icon
  },
  methods: {
    onSearch(keyword) {
      if (!keyword) return;
      this.$router.push({
        path: "/menus",
        query: {
          keyword: keyword
        }
      });
    },
    genHtmlInText(text) {
      let regexUrlPattern = /(http(s)?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+)/g;
      let genATag = function(url) {
        return '<a href="' + url + '" target="_blank" style="color:#1890ff">' + url + '</a>';
      }
      if(regexUrlPattern.test(text)) {
        return text.replace(regexUrlPattern, genATag);
      }
      return text;
    },
  },
  computed: {
    hasInq() {
      return !!this.menu?.providerInfo?.hpUrl;
    },
    hasInqFormUrl() {
      return !!this.menu?.providerInfo?.inqFormUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './style.scss';
  .open-in-new {
    a {
      span {
        color: black;
        text-decoration: underline;
      }
      svg {
        margin-left: 0.25em;
        width: 1.5em;
        vertical-align: text-bottom;
        display: inline-block;
      }
    }
  }
</style>
